/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useSelector} from 'react-redux';
import {
  showDistanceTravelledSelector,
  showDrivingTimeSelector,
  showEventsBetweenTripsSelector,
  showHarshEventsSelector,
  showIdlingTimeSelector,
  showSummarySelector,
  showTotalAssetsSelector,
  showTripVisibleSelector
} from '../../store/selectors/reports-selectors';

/**
 * The custom hook returns the AHR persisted state to the component. The state
 * contains the card informations from the redux-store.
 * 
 * ```typescript
 * 
 *  import {useAHRSettings} from './useAHRSettings';
 * 
 *  const settings = useAHRSettings();
 * 
 * ```
 */
export const useAHRSettings = () => {
  const showEventsBetweenTrips = useSelector(showEventsBetweenTripsSelector);
  const showTripVisible        = useSelector(showTripVisibleSelector);
  const showSummaryCards       = useSelector(showSummarySelector);
  const showDistanceTravelled  = useSelector(showDistanceTravelledSelector);
  const showIdlingTime         = useSelector(showIdlingTimeSelector);
  const showDrivingTime        = useSelector(showDrivingTimeSelector);
  const showHarshEvents        = useSelector(showHarshEventsSelector);
  const showTotalAssets        = useSelector(showTotalAssetsSelector);

  return {
    showEventsBetweenTrips,
    showTripVisible,
    showSummaryCards,
    showDistanceTravelled,
    showIdlingTime,
    showDrivingTime,
    showHarshEvents,
    showTotalAssets
  };
};

export default useAHRSettings;
